import { createSelector } from 'reselect'

import { LawyerChatState } from './models'

const getLawyerChatState = (state) => state.lawyerChat

export const getLawyerNotes = createSelector(
  getLawyerChatState,
  (state: LawyerChatState) => state.notes
)

export const getAuditReportData = createSelector(
  getLawyerChatState,
  (state: LawyerChatState) => state.auditReport.data
)

export const getNoLetterAddedToReport = createSelector(
  getLawyerChatState,
  (state: LawyerChatState) => !state.auditReport.selectedLetterId
)

export const getNoLetterAddedToAnswerWithoutReport = createSelector(
  getLawyerChatState,
  (state: LawyerChatState) => !state.answerWithoutReport.selectedLetterId
)

export const selectLetterRequestId = createSelector(
  getLawyerChatState,
  (state: LawyerChatState) => state.letterRequestId
)
